import http from '../_http_v2'

const site = {
  //default
  list: (m) => { return http.post(`console/wmds/site/list`, m); },
  detail: (m) => { return http.get(`console/wmds/site/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wmds/site`, m); },
  update: (m) => { return http.put(`console/wmds/site`, m); },
  delete: (m) => { return http.delete(`console/wmds/site/${m.id}`); },

  thumbnail: (m) => { return http.get(`console/wmds/site/thumbnail/${m.id}`); },

  //upload
  uploadOne: (m) => { return http.post(`console/wmds/site/upload/one`, m); },
  uploadList: (m) => { return http.post(`console/wmds/site/upload/list`, m); },
  info: (m) => { return http.post(`console/wmds/site/info`, m); },

  domain: (m) => { return http.get(`console/wmds/site/domain`, m); },
  clear: (m) => { return http.get(`console/wmds/site/clear`, m); },
  agree: (m) => { return http.get(`console/wmds/site/agree`, m); },

  //other
  rpc : (m) => { return http.post(`console/wmds/rpc/single`, m); },
}

export default site

export { site }